<template>
  <div
    class="rechercheDetailMainWrapper"
    ref="rechercheDetailMainWrapper"
  >
    <div class="navigationWrapper">
      <BasicButton
        type="reverse"
        iconName="arrow-left"
        label="Retour à la liste"
        @click="useVirementRoutingService().navigateToRechercheVirementsList"
      />
    </div>
    <div class="topWrapper">
      <BasicCard
        class="cardDesktop"
        :title="'Virement n° ' + `${store.model?.reference}`"
        :subtitles="[
          { text: store.model?.denominationBeneficiaire!, icon: 'building' },
          { text: dateTimeToReadableDate(store.model?.dateEmission!), icon: 'calendar' },
          { text: formatNumber(store.model?.montantTTC, { decimal: 2, separateur: true }) + ' €', icon: 'wallet' },
        ]"
      />
      <BasicCard
        class="cardMobile"
        :title="'Virement n° ' + `${store.model?.reference}`"
        :subtitles="[
          { text: store.model?.denominationBeneficiaire!, icon: 'building' },
          { text: dateTimeToReadableDate(store.model?.dateEmission!), icon: 'calendar' },
          { text: formatNumber(store.model?.montantTTC, { decimal: 2, separateur: true }) + ' €', icon: 'wallet' },
        ]"
      />
    </div>
    <FacturesList
      v-if="store.model?.factures?.length! > 0"
      :factures="store.model?.factures!"
    />
  </div>
</template>

<script setup lang="ts">
  import { dateTimeToReadableDate, formatNumber } from '@/features/shared/tools'
  import FacturesList from './components/FacturesList.vue'
  import { useVirementRoutingService } from './useVirementRoutingService'
  import { useVirementStore } from './useVirementStore'

  const store = useVirementStore()
</script>

<style lang="less" scoped>
  @import '../index.less';
</style>
